function PowerBIInvoices() {
  return (
    <div style={{ width: "90%", height: "90%" }}>
      <iframe
        title="Invoices"
        style={{ width: "100%", height: "100%" }}
        src="https://app.powerbi.com/reportEmbed?reportId=02f44818-6d7c-4ec6-98b2-23e23aea68f6&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default PowerBIInvoices;
